export const HOUSEWARE_OTHER_ID = 999999;

export interface Houseware {
    id: number;
    title?: string;
    avgCost?: number;
    isDisabled?: boolean;
    selected?: boolean;
}
